<template>
  <div class="notif-bell">
    <button type="button" class="notif-bell__btn" :aria-label="`Notificări${unreadCount > 0 ? ` (${unreadCount} necitite)` : ''}`" @click="goToActivityCenter">
      <svg class="notif-bell__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
      <span v-if="unreadCount > 0" class="notif-bell__badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </button>
  </div>
</template>

<script>
const UNREAD_POLL_INTERVAL_MS = 30000;

export default {
  name: 'NotificationBell',

  props: {
    currentUser: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      unreadCount: 0,
      pollInterval: null,
    };
  },

  watch: {
    currentUser(val) {
      if (val) {
        this.fetchUnreadCount();
        this.startPolling();
      } else {
        this.stopPolling();
        this.unreadCount = 0;
      }
    },
  },

  mounted() {
    if (this.currentUser) {
      this.fetchUnreadCount();
      this.startPolling();
    }
  },

  beforeUnmount() {
    this.stopPolling();
  },

  methods: {
    goToActivityCenter() {
      this.$router.push({ name: 'activity-center' });
    },

    async fetchUnreadCount() {
      if (!this.currentUser) return;
      try {
        const resp = await window.axios.get('/notifications/unread-count');
        this.unreadCount = resp.data.count || 0;
      } catch {
        // silent
      }
    },

    startPolling() {
      this.pollInterval = setInterval(() => {
        this.fetchUnreadCount();
      }, UNREAD_POLL_INTERVAL_MS);
    },

    stopPolling() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
        this.pollInterval = null;
      }
    },
  },
};
</script>
